// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--15i6G","img":"index-module--img--ayubO","link":"index-module--link--2VPCz"};